import { appPath } from "@/lib/app-version";
import { getAccessToken, removeAccessToken } from "@/features/auth/utils/token";

// Define a custom error for unauthorized responses
export class UnauthorizedError extends Error {
  constructor(message = "Unauthorized") {
    super(message);
    this.name = "UnauthorizedError";
  }
}

export const fetchWithAuth = async (
  url: string,
  options: RequestInit = {
    headers: {
      "Content-Type": "application/json",
    },
  },
) => {
  const token = getAccessToken();

  const headers = new Headers(
    options.headers || {
      "Content-Type": "application/json",
    },
  );

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    console.error("API request unauthorized (401).");
    // Attempt to delete the token directly from localStorage
    try {
      removeAccessToken();
    } catch (storageError) {
      console.error(
        "Failed to remove access token from storage:",
        storageError,
      );
    }
    // Redirect to login page (client-side)
    window.location.href = appPath("/login", window.location.pathname);
    // Throw a specific error to stop further processing
    throw new UnauthorizedError();
  }

  // For other errors or successful responses, return the response object
  // The calling function will handle .ok checks and JSON parsing
  return response;
};

export const fetchPublic = async (
  url: string,
  options: RequestInit = {
    headers: {
      "Content-Type": "application/json",
    },
  },
) => {
  const headers = new Headers(
    options.headers || {
      "Content-Type": "application/json",
    },
  );

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    console.error("API request unauthorized (401).");
    // Attempt to delete the token directly from localStorage
    try {
      removeAccessToken();
    } catch (storageError) {
      console.error(
        "Failed to remove access token from storage:",
        storageError,
      );
    }
    // Redirect to login page (client-side)
    window.location.href = appPath("/login", window.location.pathname);
    // Throw a specific error to stop further processing
    throw new UnauthorizedError();
  }

  // For other errors or successful responses, return the response object
  // The calling function will handle .ok checks and JSON parsing
  return response;
};
